import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';
import { InputLabelContainer } from '../../../../common/components/form/label/containers/input-label.container';
import { format } from '../../../../common/services/common.service';


export const GlobalRegistriesBasicInfoComponent = ({ 
    selectedDbnpRegistry
}: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

<div>
          <InputLabelContainer
              label="br_id"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.br_id}
          />
    </div>
    <div>
          <InputLabelContainer
              label="City"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.city}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Country"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.country}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Domain"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.domain}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Status"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.status}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Subscriber Id"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.subscriber_id}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Subscriber Url"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.subscriber_url}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Type"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.type}
          />
    </div>
    <div>
          <InputLabelContainer
              label="UKId"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.ukId}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Valid From"
          />
          <InputLabelContainer
              label={format(selectedDbnpRegistry?.valid_from)}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Valid Until"
          />
          <InputLabelContainer
              label={format(selectedDbnpRegistry?.valid_until)}
          />
    </div>
                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    </>
)
export default GlobalRegistriesBasicInfoComponent;
